import { CommonRequestOptions, makeRequest } from '../makeRequest';
import { SkillRatingId } from './skill-rating-id';

export async function setSupervisorRating(
   { doctype, docid, userid }: SkillRatingId,
   rating: number,
   teamid?: number,
   common: CommonRequestOptions = {}
): Promise<null> {
   if (!doctype || !docid || !userid) return null;
   return makeRequest('post', `skills/ratings/supervisor/${doctype}/${docid}/${userid}`, {
      ...common,
      body: {
         rating,
         teamid,
      },
   });
}
